<ng-container *ngIf="!isProtected || enabled">
  <ng-container *ngTemplateOutlet="ngContentTpl"></ng-container>
</ng-container>
<ng-container *ngIf="isProtected && !enabled">
  <ng-container *ngIf="!useOriginalTemplate; else originalTemplateOutlet">
    <rt-dropdown-item (click)="facade.showFeatureInfo(mode, feature)">
      <rt-icon prefix [size]="'medium'" [name]="iconName"> </rt-icon>
      <rt-heading variant="heading">
        {{ heading }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ subheading }}
      </div>
      <rt-icon suffix name="upgrade" size="small-x" colorToken="colorIconScaleDefault"></rt-icon>
    </rt-dropdown-item>
  </ng-container>
</ng-container>
<ng-template #originalTemplateOutlet>
  <div (click)="facade.showFeatureInfo(mode, feature)" class="original-tpl-wrap">
    <div class="original-tpl-content">
      <ng-container *ngTemplateOutlet="ngContentTpl"></ng-container>
      <rt-icon
        name="upgrade"
        size="small-x"
        colorToken="colorIconScaleDefault"
        class="settings-icon-link"
      ></rt-icon>
    </div>
  </div>
</ng-template>
<ng-template #ngContentTpl>
  <ng-content></ng-content>
</ng-template>
